export default __webpack_public_path__ + "static/media/course_shape.9f09d1a8.png";